import { render, staticRenderFns } from "./UiUsername.vue?vue&type=template&id=d79d39a2&"
import script from "./UiUsername.vue?vue&type=script&lang=js&"
export * from "./UiUsername.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports